export const background = "#0D1117";
export const primary = "#161B22";
export const text = "#C9D1D9";
export const subtext = "#484F58";
export const accent = "#58A6FF";
export const border = "#30363d";
export const muted = "#868E96";
export const bordermuted = "#21262D";